import WordService from "@/services/WordService";
import { root } from "@/common/consts";
import RelatedInfo from "@/components/RelatedInfo/RelatedInfo.vue";

export default {
    components: {
        RelatedInfo
    },
    props: {
        slug: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            root,
            moreLink: root.GRAMMAR,
            relatedArticles: [],
            title: this.$t("relatedArticles"),
            error: false
        };
    },
    created() {
        this.refreshComponent();
    },
    watch: {
        $route() {
            this.refreshComponent();
        }
    },
    methods: {
        refreshComponent() {
            WordService.getRelatedArticles(this.slug).then(
                res => {
                    const relatedArticles = res.data.data.articles;
                    if (relatedArticles.length < 1) {
                        this.error = true;
                    } else if (relatedArticles.length >= 1) {
                        this.error = false;
                        this.relatedArticles = relatedArticles;
                    }
                },
                err => (this.error = true)
            );
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/RelatedArticles/RelatedArticles.js